import { Permission } from '../permissions';

export const ConstructerRolePermissions = [
  /* ----- order ----- */
  'order:read',

  'order.tabs:notes',
  'order.tabs:install',
  'order.tabs:protocol',
  'order.tabs:complaints',

  // order note tab
  'order.notes.todo:read',
  'order.notes.todo:create',
  'order.notes.todo:delete',
  'order.notes.todo:edit',
  'order.notes.todo:set_state',

  'order.notes.note:read',
  'order.notes.note:create',
  'order.notes.note:edit',
  'order.notes.note:delete',

  // order install tab
  // i dont think this needs finer permissions
  'order.install:read',
  'order.install:create',
  'order.install:delete',

  // order protocol tab
  'order.protocol:read',
  'order.protocol:create',
  'order.protocol:edit',
  'order.protocol:delete',

  // order complaints tab
  // honestly idk how complaints even work
  'order.complaints:read',
  'order.complaints:edit',
  'order.complaints:set_completed',
  'order.complaints:upload_attachment',
  'order.complaints:delete',

  /* ----- calendar ----- */
  'calendar:read',
] satisfies Permission[];
